import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
export function Hero() {
  const whatsappMessage = encodeURIComponent(`Hi, I want to get Beta access of Welma.

My name is: ___
I'm a: ___ (profession)
I have approximately ___ active clients
My email is: ___`);
  const whatsappLink = `https://wa.me/919876543210?text=${whatsappMessage}`;
  return <section className="pt-24 pb-16 px-6 md:pt-32 md:pb-24 text-center max-w-4xl mx-auto" data-id="element-65">
      <div className="space-y-6 animate-fade-in" data-id="element-66">
        <span className="inline-block px-4 py-1.5 rounded-full bg-[#8B9D83]/10 text-[#5A6C52] text-sm font-medium mb-4" data-id="element-67">
          Early access for solo wellness practitioners
        </span>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2D2D] tracking-tight leading-[1.1]" data-id="element-68">
          Welma is your daily practice assistant
        </h1>

        <p className="text-lg md:text-xl text-[#2D2D2D]/80 max-w-2xl mx-auto leading-relaxed" data-id="element-69">
          Manage WhatsApp clients, follow-ups, appointments, and reminders
          without the chaos. So you can focus on the people you help.
        </p>

        <div className="pt-4" data-id="element-70">
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-[#25D366] rounded-full hover:bg-[#20BD5A] transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-71">
            <MessageCircle className="w-5 h-5 mr-2" data-id="element-72" />
            Join the beta
          </a>
        </div>
      </div>
    </section>;
}